import { render, staticRenderFns } from "./VoiActorsCloud.vue?vue&type=template&id=21da8e50&scoped=true"
import script from "./VoiActorsCloud.vue?vue&type=script&lang=js"
export * from "./VoiActorsCloud.vue?vue&type=script&lang=js"
import style0 from "./VoiActorsCloud.vue?vue&type=style&index=0&id=21da8e50&prod&scoped=true&lang=css"
import style1 from "./VoiActorsCloud.vue?vue&type=style&index=1&id=21da8e50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da8e50",
  null
  
)

export default component.exports